import React, { Component } from 'react';
import { SearchableSelect } from '../_shared/forms/FormMultiSelect';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import SubmitButton from '../_shared/SubmitButton';

const loadingArray = [{ id: null, name: 'Loading...' }];

export default class ProduceInvoiceModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            invoiceables: [],
            invoiceable: {},
            asOfDate: new Date(),
            loading: false,
        };
    }

    componentDidMount() {
        this.loadInvoiceables();
    }

    postAction = () => {
        if (!this.validateForm()) {
            return;
        }

        this.setState({ loading: true });
        axios
            .post(
                `/invoices/produce?id=${this.state.invoiceable.id}&term=${this.props.term}&date=${moment(this.state.asOfDate).format('YYYY-MM-DD')}&type=${this.props.type}`
            )
            .then(() => {
                toastr.success('Invoice produced successfully');
                window.location.reload();
            })
            .catch(() => {
                toastr.error('Something went wrong');
                window.location.reload();
            });
    };

    loadInvoiceables = () => {
        this.setState({ invoiceables: loadingArray, invoiceable: loadingArray[0] });
        axios
            .get(
                `/invoices/${this.props.type}s-as-of?term=${this.props.term}&date=${moment(this.state.asOfDate).format('YYYY-MM-DD')}`
            )
            .then((response) => {
                this.setState({ invoiceables: response.data.invoiceables, invoiceable: {} });
            })
            .catch(() => {
                this.setState({ invoiceables: [] });
                toastr.error(`Could not get ${this.props.type}s for date`);
            });
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (moment(date).isValid()) {
            this.setState({ [name]: date, errors: errorsObject });
            this.loadInvoiceables();
        } else {
            this.setState({ [name]: null });
        }
    };

    handleSearchableSelectChange = (e, name) => {
        //  Remove validation error on selected field
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (name === 'invoiceable') {
            const invoiceable = this.state.invoiceables.find((invoiceable) => invoiceable.id === e.value);

            this.setState({
                invoiceable: invoiceable,
                errors: errorsObject,
            });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = ['asOfDate', 'invoiceable'];

        fields.forEach((field) => {
            if (field === 'invoiceable') {
                if (!this.state[field].id) {
                    errors[field] = `${this.props.type} is required`;
                }
            } else {
                if (!this.state[field]) {
                    errors[field] = `${field} is required`;
                }
            }
        });

        this.setState({ errors });

        return Object.keys(errors).length === 0;
    };

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>Produce {this.props.termLabel} Invoice</h4>
                        <hr />
                        <p>
                            A new {this.props.termLabel} invoice will be generated for this {this.props.type}.{' '}
                        </p>
                        <p>If Active Invoice is sent, the new invoice will be sent if reviewed.</p>

                        <div className="form-group">
                            <label>Invoice as of (must be within invoice period)</label>
                            <DatePicker
                                name="as_of_date"
                                className="form-control"
                                placeholderText="Invoice as of..."
                                minDate={moment().add(-7, 'years').toDate()}
                                onChange={(date) => this.handleDateChange(date, 'asOfDate')}
                                selected={this.state.asOfDate}
                                dateFormat="dd/MM/yyyy"
                                error={this.state.errors.asOfDate}
                            />
                        </div>

                        <div className="form-group">
                            <SearchableSelect
                                classes={this.state.errors.invoiceable ? 'is-invalid' : ''}
                                name="invoiceable"
                                options={this.state.invoiceables}
                                value={this.state.invoiceable}
                                handleChange={this.handleSearchableSelectChange}
                                label={this.props.type}
                                error={this.state.errors.invoiceable}
                            />
                        </div>

                        <div className="form-group">
                            <button
                                loading={this.state.loading}
                                disabled={Object.keys(this.state.errors).length > 0}
                                className="btn btn-cw-primary ml-2"
                                onClick={this.postAction}
                            >
                                Produce Invoice
                            </button>
                        </div>
                        <hr />
                        <div className="admin-modal-notes-footer">
                            <button className="btn btn-cw-primary ml-2" onClick={this.props.onHide}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
